import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=77248e4c&scoped=true&lang=html&"
import script from "./Content.vue?vue&type=script&lang=js&"
export * from "./Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77248e4c",
  null
  
)

export default component.exports